import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { updateRowData } from "../../../../store/updateData";
import { getCurrentDate } from "../../../../utils/getCurrentDate";

export const createGuarantee = async (e: stdObject, params: stdObject) => {
  const {
    dispatch,
    country,
    accSerie,
    docValues,
    setMsg2,
    setModalData2,
    closeMsg,
    closeMsgDoc,
    logoutAction,
  } = params;
  try {
    setMsg2("loading");
    const payloadGuarantee = {
      accSerie,
      serie: docValues.serie,
      code: docValues.code,
      country,
      guarantee: e.CODART,
      date: getCurrentDate(true),
    };
    console.log("payloadGuarantee", payloadGuarantee);

    const responseGuarantee = await sendData({
      endPoint: "createGuarantee",
      payload: payloadGuarantee,
      logoutAction,
    });

    console.log("responseGuarantee", responseGuarantee);

    if (responseGuarantee.success) {
      dispatch(
        updateRowData({
          type: responseGuarantee.type,
          data: [responseGuarantee.data],
        }),
      );
      setTimeout(() => {
        closeMsg();
        closeMsg(2);
        setModalData2({});
        closeMsgDoc(true);
      }, 500);
    } else {
      setMsg2("error");
    }
  } catch (error) {
    setMsg2("error");
  }
};
